<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm03_title"><a id="page_iii"></a>Forging Napoleon’s Grande Armée</h1>
<p class="subtitle"><em>Motivation, Military Culture, and Masculinity in the French Army, 1800–1808</em></p>
<p class="author">Michael J. Hughes</p>
<p class="imagefm"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?e0a542ae